import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, useTheme } from "@mui/material";
import moment from "moment";

import Button from "components/basic/button";
import Typography from "components/basic/typography";
import Badge from "components/basic/badge";

import { CUSTOMER_RESPONSE_META, Meeting } from "../../../../types";

interface CustomerResponseCardProps {
  meeting: Meeting;
  onUseProposedTime: () => void;
}

const CustomerResponseCard: React.FC<CustomerResponseCardProps> = ({
  meeting,
  onUseProposedTime,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("meetings");
  const response = meeting.customerResponse
    ? CUSTOMER_RESPONSE_META[meeting.customerResponse]
    : undefined;

  if (!response) {
    return null;
  }

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}
    >
      <Typography
        variant="subtitle2"
        style={{ fontWeight: 600, marginBottom: 8 }}
      >
        {t("response_card.title")}
      </Typography>
      <Badge label={response.label} color={response.color} />
      {meeting.customerResponse === "reschedule_proposed" &&
        meeting.proposedDate &&
        meeting.proposedFrom &&
        meeting.proposedTo && (
          <Stack spacing={1} sx={{ mt: 1.5 }}>
            <Typography variant="body2">
              {t("response_card.proposed")}{" "}
              {moment(meeting.proposedDate, "YYYY-MM-DD").format("ddd, MMM D")}{" "}
              · {moment(meeting.proposedFrom, "HH:mm").format("h:mm A")} –{" "}
              {moment(meeting.proposedTo, "HH:mm").format("h:mm A")}
            </Typography>
            <Box>
              <Button
                variant="outlined"
                color="warning"
                onClick={onUseProposedTime}
              >
                {t("response_card.use_time")}
              </Button>
            </Box>
          </Stack>
        )}
    </Box>
  );
};

export default CustomerResponseCard;
